/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface OrganizationCreatePreRequestRequest
 */
export interface OrganizationCreatePreRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreatePreRequestRequest
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreatePreRequestRequest
     */
    'personName': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreatePreRequestRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreatePreRequestRequest
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreatePreRequestRequest
     */
    'employeeNumber': OrganizationCreatePreRequestRequestEmployeeNumberEnum;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreatePreRequestRequest
     */
    'plan': OrganizationCreatePreRequestRequestPlanEnum;
    /**
     * 
     * @type {number}
     * @memberof OrganizationCreatePreRequestRequest
     */
    'monthlyTransactionAmountInTenThousandsYen': number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreatePreRequestRequest
     */
    'mediaCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreatePreRequestRequest
     */
    'campaignApplicationCode': string | null;
}

export const OrganizationCreatePreRequestRequestEmployeeNumberEnum = {
    under10: 'UNDER_10',
    overOr10Under50: 'OVER_OR_10_UNDER_50',
    overOr50Under100: 'OVER_OR_50_UNDER_100',
    overOr100Under500: 'OVER_OR_100_UNDER_500',
    overOr500: 'OVER_OR_500'
} as const;

export type OrganizationCreatePreRequestRequestEmployeeNumberEnum = typeof OrganizationCreatePreRequestRequestEmployeeNumberEnum[keyof typeof OrganizationCreatePreRequestRequestEmployeeNumberEnum];
export const OrganizationCreatePreRequestRequestPlanEnum = {
    deferredPayment: 'DEFERRED_PAYMENT',
    deposit: 'DEPOSIT'
} as const;

export type OrganizationCreatePreRequestRequestPlanEnum = typeof OrganizationCreatePreRequestRequestPlanEnum[keyof typeof OrganizationCreatePreRequestRequestPlanEnum];


